/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  TestLargeCall2,
  TestLargeCall2Interface,
} from "../TestLargeCall2";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "dest",
        type: "address",
      },
      {
        components: [
          {
            internalType: "bytes32[]",
            name: "indexes",
            type: "bytes32[]",
          },
          {
            internalType: "uint256[]",
            name: "resIds",
            type: "uint256[]",
          },
          {
            internalType: "uint256[][]",
            name: "nextIds",
            type: "uint256[][]",
          },
        ],
        internalType: "struct TestLargeCall.CallData",
        name: "data",
        type: "tuple",
      },
    ],
    name: "largeCall2",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class TestLargeCall2__factory {
  static readonly abi = _abi;
  static createInterface(): TestLargeCall2Interface {
    return new Interface(_abi) as TestLargeCall2Interface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): TestLargeCall2 {
    return new Contract(address, _abi, runner) as unknown as TestLargeCall2;
  }
}
